const process = function (fieldGroups) {
  return {
    ageValue: getAgeValue(parseInt(fieldGroups[0].fields[0].value)),
    freqValue: parseInt(fieldGroups[0].fields[1].value),
    partnerValue: parseInt(fieldGroups[0].fields[2].value)
  }

  function getAgeValue (age) {
    const cutoffs = [24, 30, 40, 50, 65, Infinity]

    for (var i in cutoffs) {
      const cutoff = cutoffs[i]
      if (age < cutoff) {
        return i
      }
    }
  }
}

export default process



// WEBPACK FOOTER //
// ./assets/Process.js